<template>
    <div class="form-group">
        <b-form-group :label="field.label">
            <b-form-input
                v-if="field.type=='text' "
                v-model.trim="localValue"
                type="text"
                placeholder="Enter field label"
            ></b-form-input>
            <b-form-textarea
                v-else-if="field.type=='textarea'"
                v-model.trim="localValue"
                type="text"
                placeholder="Enter field label"
            ></b-form-textarea>
            <b-form-select
                v-else-if="field.type=='select'"
                :options="options"
                v-model.trim="localValue"
                type="text"
                placeholder="Enter field label"
            ></b-form-select>
            <b-form-radio-group
                v-else-if="field.type=='radio'"
                :options="options"
                v-model.trim="localValue"
                type="text"
                placeholder="Enter field label"
            ></b-form-radio-group>
            <b-form-checkbox-group
                v-else-if="field.type=='checkbox'"
                :options="options"
                v-model.trim="localValue"
                type="text"
                placeholder="Enter field label"
            ></b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
export default {
    props: ['field', 'value'],
    data() {
        return {
            localValue: null
        }
    },
    computed: {

        options() {
            if (this.field.values)
                return this.field.values.split('\n');
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newVal) {
            this.$emit('input', this.localValue);
        }
    },
    created() {
        this.localValue = this.value;
    },

}
</script>

<style>

</style>
